import { useRef, useState } from 'react';
import { useAdminView } from '../../context/AdminViewContext';
import { useApp } from '../../context/AppContext';
import { useAuth } from '../../context/AuthContext';
import { useI18n } from '../../i18n/useI18n';
import { useUi } from '../../context/UiContext';
import { useDismiss } from '../../hooks/useDismiss';
import { followLink } from '../../router/location';
import styles from './overlays.module.css';

export function AccountMenu({ anchorRef }) {
  const { state, actions } = useApp();
  const { user, logout, updateName } = useAuth();
  const admin = useAdminView();
  const { t } = useI18n();
  const { close, toggle } = useUi();
  const menuRef = useRef(null);
  const [confirming, setConfirming] = useState(false);
  useDismiss(true, () => close('accountOpen'), [menuRef, anchorRef].filter(Boolean));

  return (
    <div className={styles.menuUp} ref={menuRef} role="dialog" aria-label={t('account.label')}>
      {user?.email && <p className={styles.accountEmail}>{user.email}</p>}
      <label className={styles.menuLabel} htmlFor="profile-name">
        {t('account.name')}
      </label>
      <input
        id="profile-name"
        className={styles.nameInput}
        value={state.profile.name}
        autoComplete="name"
        onChange={(event) => actions.setProfile(event.target.value)}
        onBlur={(event) => {
          if (event.target.value.trim() !== user?.name) updateName(event.target.value);
        }}
      />
      {state.profile.waitlist && <p className={styles.note}>{t('account.waitlist')}</p>}
      {admin?.enabled && (
        <a
          href="/admin"
          className={styles.menuBtn}
          onClick={(event) => {
            followLink(event, () => {
              close('accountOpen');
              admin.openAdmin();
            }, '/admin');
          }}
        >
          {t('account.admin')}
        </a>
      )}
      <button
        type="button"
        className={styles.menuBtn}
        onClick={() => {
          close('accountOpen');
          toggle('helpOpen');
        }}
      >
        {t('account.shortcuts')}
      </button>
      {confirming ? (
        <div className={styles.confirm}>
          <button type="button" onClick={() => setConfirming(false)}>
            {t('account.cancel')}
          </button>
          <button
            type="button"
            onClick={() => {
              actions.resetContent();
              close('accountOpen');
            }}
          >
            {t('account.reset')}
          </button>
        </div>
      ) : (
        <button type="button" className={styles.menuBtn} onClick={() => setConfirming(true)}>
          {t('account.resetBoard')}
        </button>
      )}
      <button type="button" className={styles.menuBtn} onClick={() => logout()}>
        {t('account.signOut')}
      </button>
    </div>
  );
}
